import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePlatformAuth } from "../context/platformAuth";

export function SystemLoginPage() {
  const nav = useNavigate();
  const { login } = usePlatformAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    try {
      setError("");
      await login(email, password);
      nav("/sys/dashboard");
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-3">
      <form className="panel p-6 w-full max-w-md grid gap-3" onSubmit={submit}>
        <h1 className="text-2xl font-semibold">System Manager Login</h1>
        <p className="text-sm text-slate-500">Bootstrap credentials are configured via BOOTSTRAP_PLATFORM_* env vars.</p>
        <input className="input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input className="input" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="btn" type="submit">
          Enter Console
        </button>
        {error ? <p className="text-red-600 text-sm">{error}</p> : null}
      </form>
    </div>
  );
}

